<template>
  <span v-if="status !== 'idle'" class="asv" :class="status">
    <template v-if="status === 'saving'">Saving…</template>
    <template v-else-if="status === 'saved'"><AppIcon name="check_circle" :size="13" /> Saved</template>
    <template v-else-if="status === 'error'">
      {{ errorMessage || 'Couldn’t save' }} ·
      <button class="asv-retry" type="button" @click="$emit('retry')">Retry</button>
    </template>
  </span>
</template>

<script setup lang="ts">
import AppIcon from '../../../components/AppIcon.vue'
import type { AutosaveStatus } from '../../composables/useAutosave'

defineProps<{ status: AutosaveStatus; errorMessage?: string }>()
defineEmits<{ (e: 'retry'): void }>()
</script>

<style scoped>
.asv {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  font-size: 12px;
  font-weight: 600;
  white-space: nowrap;
}
.asv.saving { color: var(--muted); }
.asv.saved { color: var(--success, #16a34a); }
.asv.error { color: var(--danger); }
.asv-retry {
  background: none;
  border: none;
  padding: 0;
  font: inherit;
  color: var(--primary);
  cursor: pointer;
  text-decoration: underline;
}
</style>
